const colors = {
  main: {
    success: '#2ecb64',
    info: '#5695fe',
    warning: '#fc8c3a',
    danger: '#f44336',
    gray: '#525b64',
    grayLight: '#d3d3d4',
    grayVeryLight: '#f2f2f2',
    blueGray: '#4c6c9b',
    dark: '#222222',
  },
  unique: {
    white: '#fff',
    black: '#000',
    grayLight: '#F2F2F2',
    transparent: 'transparent',
  },
  custom: {
    blueLight: '#00a7e7',
    lime: '#bed600',
    greyDark: '#696969',
    aliceBlue: `#F0F8FF`,
    battleshipGrey: '#434343',
  },
  primary: {
    midnightBlue: '#001E62',
    midnightBlueHovering: '#1F3D82',
    blue: '#00A9E0',
    lime: '#BED600',
    grey: '#8B8D8E',
  },
  secondary: {
    purple: '#A05599',
    yellow: '#FAE700',
    pink: '#E3007B',
    orange: '#FFA100',
    red: '#E5352C',
    whitesmoke: '#F5F5F5',
    grey90: '#E5E5E5',
    grey95: '#F4F4F4',
  },
  opacity: {
    black70: 'rgba(0, 0, 0, 0.7)',
    white20: 'rgba(255, 255, 255, 0.2)',
    white80: 'rgba(255, 255, 255, 0.8)',
    white60: 'rgba(255, 255, 255, 0.6)',
    black20: 'rgba(0, 0, 0, 0.2)',
    black80: 'rgba(0, 0, 0, 0.8)',
    black90: 'rgba(0, 0, 0, 0.9)',
  },
}

export default colors
